import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { useReportsDeleteMutation } from "../../crm/hooks/useDeleteReport";

interface ReportDeleteModalProps {
  open: boolean;
  onClose: () => void;
  reportId?: number;
}

export const DeleteReportsConfirmationModal = (props: ReportDeleteModalProps) => {
  const { open, onClose, reportId } = props;
  const { deleteReport } = useReportsDeleteMutation(Number(reportId));

  const handleDelete = () => {
    deleteReport();
    onClose();
  };

  return (
    <>
      <Modal size='tiny' open={open} onClose={onClose}>
        <Modal.Header>Delete Reports Confirmation</Modal.Header>
        <Modal.Content>
          Are you sure you want to delete this report? All data for this report will be lost.
        </Modal.Content>
        <Modal.Actions>
          <Button
            className='tw-border tw-border-solid tw-border-grey-light tw-bg-white tw-text-black '
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button color='blue' onClick={handleDelete}>
            Delete Report
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
